import { Storage } from "itsf-ui-common";
import { ICart } from "@features/cart/ICart";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";

const STORAGE = "eir-eshop";
const storage = () => new Storage(sessionStorage);

export interface IStorage {
    cart?: ICart;
    prequal?: IEirSalesPrequal;
    isLinked: boolean;
    prospectReference?: string;
    isBroadbandPromoDrawerDismissed?: boolean;
    isBroadbandEmailSent?: boolean;
}

export const loadStorage = <T = Partial<IStorage>>(): T => storage().load(STORAGE);

const saveStorage = <T extends Partial<IStorage>>(dataToStore: T) => {
    const newStorage = Object.assign(loadStorage<Partial<IStorage>>(), dataToStore);
    storage().save(STORAGE, newStorage);
};

export const removeItemFromStorage = (keyToRemove: keyof IStorage) => {
    const storageLoaded = loadStorage<Partial<IStorage>>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [keyToRemove]: _, ...rest } = storageLoaded;
    storage().save(STORAGE, rest);
};

export const clearStorage = () => {
    storage().clear();
};

export const saveUserInformation = (prospectReference: string) => {
    saveStorage({ prospectReference });
};

export const saveCart = (cart: ICart) => {
    saveStorage({ cart });
};

export const saveLinkedUser = () => {
    saveStorage({ isLinked: true });
};

export const savePrequal = (prequal: IEirSalesPrequal) => {
    saveStorage({ prequal });
};

export const getProspectReference = () => loadStorage<{ prospectReference: string }>().prospectReference;

export const getCart = () => loadStorage<{ cart: ICart }>().cart;

export const getIsUserLinked = () => loadStorage<{ isLinked: boolean }>().isLinked;

export const getPrequal = () => loadStorage<{ prequal: IEirSalesPrequal }>().prequal;

export const getIsBroadbandPromoDrawerDismissed = () =>
    loadStorage<{ isBroadbandPromoDrawerDismissed?: boolean }>().isBroadbandPromoDrawerDismissed === true;

export const saveBroadbandPromoDrawerDismissed = () => {
    saveStorage({ isBroadbandPromoDrawerDismissed: true });
};

export const clearBroadbandPromoDrawerDismissed = () => {
    removeItemFromStorage("isBroadbandPromoDrawerDismissed");
};

export const getIsBroadbandEmailSent = () =>
    loadStorage<{ isBroadbandEmailSent?: boolean }>().isBroadbandEmailSent === true;

export const saveBroadbandEmailSent = () => {
    saveStorage({ isBroadbandEmailSent: true });
};

export const clearBroadbandEmailSent = () => {
    removeItemFromStorage("isBroadbandEmailSent");
};
